import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AlreadyLoggedInGuard } from '@app/auth-guards/already-logged-in.guard';
import { LandingComponent } from './components/landing.component';

const routes: Routes = [{path: '', component: LandingComponent, canActivate: [AlreadyLoggedInGuard]}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LandingRoutingModule {}
